/* eslint-disable jsx-a11y/media-has-caption */

import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import MediaQuery from 'react-responsive'
import cloudinaryVideoUrl, {
  DEVICE_TYPE,
} from '@scentregroup/ui/tools/cloudinary/video'

import {
  ratioOptions,
  getImageHeight,
} from '@scentregroup/ui/tools/cloudinary/image'
import LazyLoad from 'react-lazyload'
import style from '../responsive-asset/index.module.scss'
import { withAngleMaskClasses } from '../../helpers/with-angle'

const HAVE_CURRENT_DATA = 2 // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState

export class RawResponsiveVideo extends React.Component {
  constructor(props) {
    super(props)
    this.videoNode = React.createRef()
  }

  componentDidMount() {
    // Make sure onLoad is still fired if the video was already loaded via SSR
    if (
      this.videoNode.current &&
      this.videoNode.current.readyState >= HAVE_CURRENT_DATA
    ) {
      this.onLoad()
    }
  }

  onLoad = event => {
    if (this.props.onLoad) {
      this.props.onLoad(event)
    }
  }

  onError = event => {
    if (this.props.onError) {
      this.props.onError(event)
    }
  }

  render() {
    const {
      angleOrigin,
      angleClasses,
      className,
      videoUrl,
      mobileRatio = 'standard',
      desktopRatio = 'standard',
      numberOfItems = 1,
      lazyLoad,
      dataTestId,
    } = this.props

    const videoContent = (
      <div
        className={classNames(
          style.ResponsiveAsset,
          className,
          style[`desktopRatio_${desktopRatio}`],
          style[`mobileRatio_${mobileRatio}`],
          {
            [angleClasses[angleOrigin]]: angleOrigin,
          }
        )}
      >
        <video
          playsInline
          autoPlay
          loop
          muted
          controls={false}
          className={style.ResponsiveAsset}
          ref={this.videoNode}
          data-test-id={dataTestId}
          onLoadedData={this.onLoad}
          onError={this.onError}
        >
          <MediaQuery query="(max-width: 767px)">
            <source
              type="video/mp4"
              src={cloudinaryVideoUrl({
                contentfulUrl: videoUrl,
                deviceType: DEVICE_TYPE.mobile,
                removeAudio: true,
              })}
            />
          </MediaQuery>
          <MediaQuery query="(min-width: 768px)">
            <source
              type="video/mp4"
              src={cloudinaryVideoUrl({
                contentfulUrl: videoUrl,
                deviceType: DEVICE_TYPE.desktop,
                removeAudio: true,
              })}
            />
          </MediaQuery>
        </video>
      </div>
    )

    return lazyLoad ? (
      <LazyLoad
        offset={800}
        height={getImageHeight({
          ratio: mobileRatio,
          numberOfItems,
        })}
      >
        {videoContent}
      </LazyLoad>
    ) : (
      videoContent
    )
  }
}

RawResponsiveVideo.defaultProps = {
  numberOfItems: 1,
}

RawResponsiveVideo.propTypes = {
  angleClasses: PropTypes.object.isRequired,
  angleOrigin: PropTypes.oneOf([
    'bottom-left',
    'top-left',
    'top-right',
    'bottom-right',
  ]),
  className: PropTypes.string,
  videoUrl: PropTypes.string,
  mobileRatio: PropTypes.oneOf(ratioOptions),
  desktopRatio: PropTypes.oneOf(ratioOptions),
  numberOfItems: PropTypes.number,
  lazyLoad: PropTypes.bool,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
  dataTestId: PropTypes.string,
}

export default withAngleMaskClasses(RawResponsiveVideo)
